import { UNITS_PER_TILE } from "./constants";
import type {
  ArchetypeDefinition,
  CharacterClass,
  MonsterDefinition,
  MonsterKind,
} from "./types";

export const ARCHETYPES: Record<CharacterClass, ArchetypeDefinition> = {
  vanguard: {
    id: "vanguard",
    name: "Vanguard",
    role: "Close-range survivor",
    description:
      "Break the line with a broad cleave and a concussive ember sweep.",
    health: 160,
    armor: 30,
    moveSpeed: 64,
    attackDamage: 18,
    abilityDamage: 32,
    attackCooldown: 30,
    abilityCooldown: 240,
    attackRange: Math.round(1.6 * UNITS_PER_TILE),
    accent: "#f0a24b",
    dark: "#71351f",
  },
  ranger: {
    id: "ranger",
    name: "Ranger",
    role: "Mobile marksman",
    description:
      "Keep distance with swift arrows and a three-shot piercing fan.",
    health: 105,
    armor: 10,
    moveSpeed: 72,
    attackDamage: 13,
    abilityDamage: 21,
    attackCooldown: 24,
    abilityCooldown: 270,
    attackRange: 9 * UNITS_PER_TILE,
    accent: "#9fc96d",
    dark: "#3e5d38",
  },
  arcanist: {
    id: "arcanist",
    name: "Arcanist",
    role: "Arcane controller",
    description:
      "Launch crystal sparks, then collapse nearby enemies with a pulse ring.",
    health: 90,
    armor: 5,
    moveSpeed: 66,
    attackDamage: 15,
    abilityDamage: 28,
    attackCooldown: 36,
    abilityCooldown: 300,
    attackRange: 8 * UNITS_PER_TILE,
    accent: "#54d4c7",
    dark: "#275b65",
  },
};

export const MONSTERS: Record<MonsterKind, MonsterDefinition> = {
  ashfang: {
    id: "ashfang",
    name: "Ashfang",
    health: 36,
    armor: 0,
    moveSpeed: 44,
    attackDamage: 8,
    attackRange: 850,
    attackCooldown: 75,
    xp: 15,
    color: "#d45f52",
  },
  hexer: {
    id: "hexer",
    name: "Rift Hexer",
    health: 28,
    armor: 0,
    moveSpeed: 34,
    attackDamage: 7,
    attackRange: 5 * UNITS_PER_TILE,
    attackCooldown: 105,
    xp: 20,
    color: "#b46bd6",
  },
  stonekin: {
    id: "stonekin",
    name: "Stonekin",
    health: 80,
    armor: 20,
    moveSpeed: 28,
    attackDamage: 10,
    attackRange: 1050,
    attackCooldown: 110,
    xp: 35,
    color: "#a9765b",
  },
};
